const MuiAutocomplete = {
  styleOverrides: {
    inputRoot: {
      paddingTop: 4,
    },
  },
}

export default MuiAutocomplete
